import { render, staticRenderFns } from "./BringupsToday.vue?vue&type=template&id=7255a239"
import script from "./BringupsToday.vue?vue&type=script&lang=js"
export * from "./BringupsToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports